<template>
    <main class="source-viewer-code">
        <ui-copy-button class="source-viewer-code__copy" v-if="contentToCopy" v-bind:copy="contentToCopy"/>

        <div v-if="!displayedContent" class="source-viewer-code__skeletons">
            <span v-pre class="skeleton" style="width: 10%"></span>
            <span v-pre class="skeleton" style="width: 60%"></span>
            <span v-pre class="skeleton" style="width: 30%"></span>
            <span v-pre class="skeleton" style="width: 20%"></span>
            <span v-pre class="skeleton" style="width: 80%"></span>
            <span v-pre class="skeleton" style="width: 60%"></span>
        </div>

        <pre v-else class="source-viewer-code__pre" v-html="displayedContent"/>
    </main>
</template>

<script>
import { highlight } from '~/lib/highlight.js';

/**
 * @param  {String} filename
 * @return {String}
 */
const guessLanguageByFileName = (filename) => { // eslint-disable-line arrow-body-style
    return filename.endsWith('.fif')
        ? 'fift'
        : 'func';
};

export default {
    props: {
        content: String,
        fullPath: String,
        filename: String,
    },

    data() {
        return {
            displayedContent: null,
            contentToCopy: null,
        };
    },

    mounted() {
        this.loadData();
    },

    watch: {
        content() {
            this.loadData();
        },
    },

    methods: {
        async loadData() {
            if (!this.content) return;

            const language = guessLanguageByFileName(this.filename);

            this.displayedContent = await highlight(this.content, language);
            this.contentToCopy = this.content;
        },
    },
};
</script>
